export class Model {
    constructor(
        public firstName : string,
        public lastName : string
    ){
    }
}
